import { IVehicleForPayment, IPaymentOverride } from '@makemydeal/dr-platform-types';

export const SPONSOR = 'SPONSOR';
export const VIN = 'VIN';
export const SELECTEDTERM = 'selectedTerm';
export const CREDITSCORE = 'creditScore';
export const DOWNPAYMENT = 'downPayment';


export type TradeCondition = 'fair' | 'good' | 'very good' | 'excellent';
export type TradeSource = 'KBB' | 'ICO' | 'USER';
export type TradeStatus = 'CLEARED' | 'INELIGIBLE' | 'FR';

export type SPSource = typeof SPONSOR | typeof VIN;
export type AllowedFallbackFields = typeof SELECTEDTERM | typeof CREDITSCORE | typeof DOWNPAYMENT;

export interface ISourceIncentive {
    cash: number;
    description: string;
    endDate: string; // ISO Date
    exclusions: number[];
    financeMethod: string;
    incentiveId: number;
    incentiveType: string;
    isStandardIncentive: boolean;
    programId: string;
    programName: string;
    startDate: string; // ISO Date
    termIncentives?: any;
}

export interface ISourceIncentivesGroup {
    conditional?: ISourceIncentive[];
    nonConditional?: ISourceIncentive[];
}

export interface ISourcePaymentAndIncentives {
    incentives?: ISourceIncentivesGroup;
    payments?: any[];
    fees?: any;
}

export interface IMappedIncentive {
    description: string;
    endDate: string;
    exclusions?: number[];
    id: number;
    incentiveType: string;
    name: string;
    programId: string;
    startDate: string;
    amount?: number;
}

export interface IMappedIncentivesGroup {
    conditionals?: IMappedIncentive[];
    nonConditionals?: IMappedIncentive[];
}

export interface IMappedPaymentAndIncentivesResult {
    incentives?: IMappedIncentivesGroup;
    payments?: any[];
    success: boolean;
}

export interface IDealSetupDealer {
    dnaAccountId?: string;
    id?: number;
    ownerId?: number;
    sponsor?: string;
}

export interface IDealSetupTrade {
    amountOwed: number;
    condition: TradeCondition;
    isNetTradeAppliedToFinancing: boolean;
    make: string;
    mileage: number;
    model: string;
    source: TradeSource;
    status?: TradeStatus;
    trim: string;
    value: number;
    vin?: string;
    year: number;
}

export interface IDealSetupShopper {
    comment?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    pixallId?: string;
    messageToDealer?: string;
    zip?: string;
    streetAddress?: string;
    state?: string;
    city?: string;
}
export interface IDealSetupRequestPayload {
    dealer: IDealSetupDealer;
    vehicle: IVehicleForPayment;
    source: SPSource;
    payment?: IPaymentOverride;
    shopper?: IDealSetupShopper;
    trade?: IDealSetupTrade;
    skipSavingOffer?: boolean;
}
